import { gql } from '@apollo/client';

// ====================== QUERY ====================== //
const QUERY_ITEM = gql`
    query ppm($input: PPMInput!){
        ppm(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const QUERY_ITEMS = gql`
    query ppms($input: PPMsInput){
        ppms(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const QUERY_LOOKUP_ITEMS = gql`
    query ppms($input: PPMsInput){
        ppms(input: $input){
            # id
            uuid
            code
            name
            company
            # created_at
            # created_by
            # updated_at
            # updated_by
        }
    }
`
const QUERY_ITEMS_BY_PAGE = gql`
    query ppmsByPage($input: PPMsByPageInput!){
        ppmsByPage(input: $input){
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
            currentPage
            prevPage
            nextPage
            totalPages
            totalItems
            ppms{
                id
                uuid
                code
                name
                company
                created_at
                created_by
                updated_at
                updated_by
            }
        }
    }
`
// ====================== MUTATION ====================== //
const MUTATION_CREATE_ITEM = gql`
    mutation createPPM($input: CreatePPMInput!){
        createPPM(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_CREATE_ITEMS = gql`
    mutation createPPMs($input: [CreatePPMInput]!){
        createPPMs(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_DELETE_ITEM = gql`
    mutation deletePPM($input: DeletePPMInput!){
        deletePPM(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_DELETE_ITEMS = gql`
    mutation deletePPMs($input: DeletePPMInput!){
        deletePPMs(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_EXPORT_ITEMS = gql`
    mutation exportPPMs($input: PPMsInput!, $by: ActionByInput!){
        exportPPMs(input: $input, by: $by){
           uuid
           size
           key
           name
           status
           topic
           type
           url
           company
           created_at
           created_by
           updated_at
           updated_by
        }
    }
`
const MUTATION_UPDATE_ITEM = gql`
    mutation updatePPM($input: UpdatePPMInput!){
        updatePPM(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`

// ====================== CREATE GQL ====================== //
const ppmGQL = {
    query: {
        getItem: QUERY_ITEM,
        getItems: QUERY_ITEMS,
        getLookupItems: QUERY_LOOKUP_ITEMS,
        getItemsByPage: QUERY_ITEMS_BY_PAGE,
    },
    mutation: {
        createItem: MUTATION_CREATE_ITEM,
        createItems: MUTATION_CREATE_ITEMS,
        deleteItem: MUTATION_DELETE_ITEM,
        deleteItems: MUTATION_DELETE_ITEMS,
        exportItems: MUTATION_EXPORT_ITEMS,
        updateItem: MUTATION_UPDATE_ITEM,
    },
    response: {
        getItem: "ppm",
        getItems: "ppms",
        getLookupItems: "ppms",
        getItemsByPage: "ppmsByPage",
        createItem: "createPPM",
        createItems: "createPPMs",
        deleteItem: "deletePPM",
        deleteItems: "deletePPMs",
        exportItems: "exportPPMs",
        updateItem: "updatePPM",
    }
}

// ====================== EXPORT ====================== //
export {
    ppmGQL,
}